import React, { useState, useEffect } from "react";
import { Nav } from "reactstrap";
import classNames from "classnames";
//Api
import notificacao_api from "../../api/notificacao_api";
import setup_api from "../../api/setup_api";

//Components
import SideBarItem from "./SideBarItem";
import SubMenu from "./SubMenu";
import "../../assets/css/sidebar.css"

//Helpers
import { showMessage } from "../../helpers/message";

const SideBar = ({ isOpen, toggle, moduloUtilizado, routes }) => {
    const [justificativasPendentes, setJustificativasPendentes] = useState(false);
    const [logos, setLogos] = useState(null);

    const loadLogoTiposCidade = () => {
        setup_api.GetLogotiposPrefeituraSidebar()
            .then(response => {
                setLogos(response.data)
            })
            .catch(err => showMessage("Erro", "Error na operação.", "error", null));
    }

    useEffect(() => {
        loadLogoTiposCidade();
    }, []);

    useEffect(() => {
        if (moduloUtilizado.sigla != "FS" && routes.filter(r => r.codigoFuncionalidade == "Notificacoes").length > 0) {
            notificacao_api.PendentesDeJustificativa().then(response => {
                setJustificativasPendentes(response.data);
            }).catch(e => showMessage("Aviso", e.message, "error", null));
        }

    }, [routes]);


    return (
        <div className={classNames("sidebar", { "is-open": isOpen })}>
            <div className="sidebar-header shadow-sm">
                <span color="info" onClick={toggle} style={{ color: "#06414B" }}>
                    &times;
                </span>
                <img className="p-4 w-75 m-4" src={require("../../assets/img/LogoSistema.png")} alt="Logo do sistema" />
            </div>
            <div className="side-menu">
                <Nav vertical className="list-unstyled pb-3">
                    <div className="w-100 d-flex align-items-center justify-content-center">
                        <p className="moduleDescriptionSidebar ">{moduloUtilizado.title}</p>
                    </div>
                    {routes.map((route, key) => {
                        if (!route.submenus) {
                            if (route.icon && route.name) {
                                return (<SideBarItem key={key} icon={route.icon} text={route.name} link={route.path} active={route.active} warning={route.codigoFuncionalidade == "Notificacoes" && justificativasPendentes} />)
                            }
                        } else {
                            if (route.icon && route.name) {
                                return (<SubMenu key={key} title={route.name} icon={route.icon} items={route.submenus} />)
                            }
                        }
                    })}
                </Nav>
                {logos &&
                    <div className="text-center">
                        {logos?.logotipo && <img className="mb-1" style={{ maxWidth: '80%'}}  id="img_logotipo" src={"data:image/png;base64," + logos.logotipo}></img>}
                        {logos?.logotipoSecretaria && <img style={{ maxWidth: '80%'}}  id="img_logotipo" src={"data:image/png;base64," + logos.logotipoSecretaria}></img>}
                    </div>
                }
            </div>
        </div>
    )
};


export default SideBar;
